import React from 'react'

export default function SearchPackages() {
  return (
    <div>
      SearchPackages
    </div>
  )
}
